import React, { useState } from "react";
import { FormItemHiddenUi } from "../../../../../ui/FormItemHiddenUi";
import { Col, Form, Row } from "antd";
import { SearchSelectUI } from "../../../../../ui/SearchSelectUI";
import { search_comprobantecompras_by_filter } from "../../../../../../actions/produccion";
import { SearchComprobanteCompraTable } from "./SearchComprobanteCompraTable";
import { SwitchUi } from "../../../../../ui";
import { ProveedorDropdown } from "./../../../../../generales/proveedores/reusable/ProveedorDropdown";

export const SearchComprobanteCompraForm = () => {
  const [comprobantesCompra, setComprobantesCompra] = useState([]);
  const [detalleComprobanteCompra, setDetalleComprobanteCompra] = useState([]);
  const form = Form.useFormInstance();
  const proveedor = Form.useWatch("proveedor", form);
  const change_proveedor = Form.useWatch("change_proveedor", form);
  const onSearch = async (value) => {
    if (!!value) {
      const data = await search_comprobantecompras_by_filter(proveedor, value);
      const options = data?.map((x) => ({
        value: x?.id,
        label: x?.comprobante_label,
        detallescomprobantecompra: x?.detallescomprobantecompra,
      }));
      setComprobantesCompra(options);
    }
  };
  const handleChange = (value, field) => {
    setDetalleComprobanteCompra(field?.detallescomprobantecompra);
  };
  return (
    <>
      <FormItemHiddenUi name="proveedor" />
      <FormItemHiddenUi name="detallecomprobantecompra" />
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={19}>
          <ProveedorDropdown
            name="proveedor"
            nameSearchText="proveedor_nombre"
            label="Emitido por"
            placeholder="[-Seleccione-]"
            disabled={!change_proveedor}
          />
        </Col>
        <Col span={5}>
          <Form.Item name="change_proveedor" label="¿Es otro emisor?">
            <SwitchUi />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            name="comprobantecompra"
            label="Buscar por número de comprobante"
          >
            <SearchSelectUI
              placeholder="Número comprobante compra"
              handleSearch={onSearch}
              onChange={handleChange}
              data={comprobantesCompra}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={24}>
          <SearchComprobanteCompraTable data={detalleComprobanteCompra} />
        </Col>
      </Row>
    </>
  );
};
